<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.doorbaseinfo_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/door/baseinfo/doorbaseinfo';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        align: 'center',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        labelWidth: 110,
        columnBtn: false,
        dialogWidth: '30%',
        span: 24,
        column: [
          {
            label: '小区名称',
            prop: 'communityName',
            display: false,
            rules: [
              {
                required: true,
                message: '请输入小区名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '小区',
            prop: 'communityId',
            dataType: 'string',
            type: 'tree',
            hide: true,
            search: true,
            editDisabled: true,
            dicUrl: '/api/door/setting/getCommunityList',
            props: {
              label: 'communityName',
              value: 'communityId',
            },
            rules: [
              {
                required: true,
                message: '请输入选择小区',
                trigger: 'change',
              },
            ],
          },
          {
            label: '门禁名称',
            prop: 'doorName',
            rules: [
              {
                required: true,
                message: '请输入门禁名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '门禁系统编号',
            prop: 'doorCode',
            rules: [
              {
                required: true,
                message: '请输入门禁系统编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '门禁品牌',
            prop: 'doorDeviceBrand',
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=door_device_brand',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
            editDisabled: true,
            rules: [
              {
                required: true,
                message: '请选择门禁品牌',
                trigger: 'change',
              },
            ],
          },
          {
            label: 'appKey',
            prop: 'appKey',
          },
          {
            label: 'appSecret',
            prop: 'appSecret',
          },
        ],
      },
      data: [],
    };
  },
  activated() {
    let self = this;
    setTimeout(() => {
      this.$refs.crud.doLayout(); //解决表格错位
    }, 0);
  },
  mounted() {
    let self = this;
    setTimeout(() => {
      window.addEventListener(
        'resize',
        () => {
          self.$refs.crud.doLayout(); //窗口缩放解决表格错位
        },
        false
      );
    }, 0);
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.doorbaseinfo_add, true),
        viewBtn: this.vaildData(this.permission.doorbaseinfo_view, true),
        delBtn: this.vaildData(this.permission.doorbaseinfo_delete, true),
        editBtn: this.vaildData(this.permission.doorbaseinfo_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('此操作将删除关联数据，是否执行?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
